import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import PostProjectGroup from '@/views/Project/Project/dialogs/postProjectGroup/postProjectGroup.vue'
import LogProjectGroupDialog from '@/views/Project/Project//dialogs/logProjectGroup/logProjectGroup.vue'
import Log from '@/views/Log/models/log'

export default class ProjectGroup extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    get hasUserSettings() {
        return this._relationships['userSettings'] ? true : false
    }

    get userSettings() {
        return this.hasUserSettings ? this._relationships['userSettings'] : null
    }

    get projects() {
        return this._relationships['projects']
    }

    static async list(query) {
        let res = await Vue.prototype.$vbit.get('project', 'projectGroups', query)

        let projectGroup = res.data.map((item) => new ProjectGroup(item, res.included))

        return projectGroup
    }

    static async startPost() {
        return await JsonApiObject.openDialog(PostProjectGroup, {})
    }

    static async post(data) {
        let query = {
            include: ['projects', 'userSettings'],
            body: { data: data },
        }

        let res = await Vue.prototype.$vbit.post('project', `projectGroups`, query)

        return new ProjectGroup(res.data, res.included)
    }

    static async showLog(projectGroup) {
        await JsonApiObject.openDialog(LogProjectGroupDialog, { projectGroup: projectGroup })
    }

    static async getLog(projectGroupId: string, timeStamp: any) {
        let data = {
            'filter[activityLogEntityId]': projectGroupId,
            'filter[activityLogNumber]': ['1'],
            'filter[time][lt]': timeStamp,
        }

        let res = await Log.getLog(data)

        return res
    }
}
